import * as React from "react";
import { connect } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import LoadingSpinner from "src/shared/LoadingSpinner";
import { getSSOCredentials, getSSORedirectUrl } from "../login/selector";
import { isUserAuthenticated } from "../route/selector";
import selectorsToProps from "../utils/selectorsToProps";
import { exchangeCode, ExchangeCodeActionType } from "./actions";
import { getUserRole } from "./selector";

interface RedirectComponentProps {
  exchangeCode: ExchangeCodeActionType;
  isUserAuthenticated: boolean;
  role: string;
  ssoRedirectUrl: string;
  ssoCredentials: string;
}

function RedirectComponent(props: RedirectComponentProps) {
  const search = useLocation().search;
  const code = new URLSearchParams(search).get("code");

  const redirectToSpreads = () => {
    if (code) {
      props.exchangeCode({
        code,
        grantType: "authorization_code",
        redirectUri: props.ssoRedirectUrl,
        scope: "openid",
        ssoCredentials: props.ssoCredentials
      });
    }
  };
  React.useEffect(redirectToSpreads, []);

  if (props.isUserAuthenticated) {
    // tslint:disable-next-line: no-console
    console.log("getUserRole", props.role);

    if (props.role === "spreader") {
      localStorage.setItem("org", "mmas-dev");
      return <Redirect to="/organizations" />;
    } else {
      return <Redirect to="/spreads" />;
    }
  }

  return (
    <div>
      <LoadingSpinner />
    </div>
  );
}

export default connect(
  selectorsToProps({
    isUserAuthenticated,
    role: getUserRole,
    ssoRedirectUrl: getSSORedirectUrl,
    ssoCredentials: getSSOCredentials
  }),
  {
    exchangeCode: exchangeCode.action
  }
)(RedirectComponent);



// WEBPACK FOOTER //
// ./src/redirectComponent/RedirectComponent.tsx